"use strict";

jQuery(document).ready(function ($) {
  // const scrollerImages = document.querySelector(".image-scroller__images");
  var scrollerImages = gsap.utils.toArray('.image-scroller__images');
  function getScrollAmount(scrollerImage) {
    var scrollerWrap = scrollerImage.closest(".image-scroller__wrap");
    var scrollerWrapRect = scrollerWrap.getBoundingClientRect();
    var scrollerImagesWidth = scrollerImage.scrollWidth;
    return -(scrollerImagesWidth + scrollerWrapRect.x * 2 - window.innerWidth);
  }
  scrollerImages.forEach(function (scrollerImage) {
    gsap.to(scrollerImage, {
      x: getScrollAmount(scrollerImage),
      duration: 3,
      ease: "none",
      scrollTrigger: {
        trigger: ".image-scroller__wrap",
        start: "top 25%",
        end: function end() {
          return "+=".concat(getScrollAmount(scrollerImage) * -1);
        },
        pin: true,
        scrub: 1,
        refreshPriority: 1
      }
    });
  });
});